// src/com/user_alloc/UserAllocGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * USER_ALLOC Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-09-23 10:04:54 using DbdbTap
 ************************************************ */

const USER_ALLOC_LIST_PART = gql`
fragment UserAllocListPart on UserAlloc {
    userAllocSeq
    userId
    userName
    password
    zipCd
    addr
    telno
    mobile
    email
    authClassId
    dcCd
    storeId
    comId
    allocTypeCd
    allocType
    allocIp
    allocFlag
    allocFlagLabel
    allocDate
    allDc
    note
    regDate
    regUser
    className
    dcName
    comName
    storeName
    regUserName
}
`;


export const LIST_USER_ALLOC = gql`
${USER_ALLOC_LIST_PART}
query ListUserAlloc {
    userAllocList {
        ...UserAllocListPart
    }
}
`;

export const GET_USER_ALLOC = gql`
${USER_ALLOC_LIST_PART}
query GetUserAlloc($userAllocSeq:Int!) {
    userAllocItem(userAllocSeq:$userAllocSeq) {
        ...UserAllocListPart
    }
}
`;

export const ADD_USER_ALLOC = gql`
mutation AddUserAlloc($userAlloc:InputUserAllocAdd!) {
	userAllocAdd(userAlloc: $userAlloc) {
		ok
		message
	}
}
`;

export const EDIT_USER_ALLOC = gql`
mutation EditUserAlloc($userAlloc:InputUserAllocEdit!) {
	userAllocEdit(userAlloc: $userAlloc) {
		ok
		message
	}
}
`;

export const REMOVE_USER_ALLOC = gql`
mutation RemoveUserAlloc($userAlloc:InputUserAllocRemove!) {
	userAllocRemove(userAlloc: $userAlloc) {
		ok
		message
	}
}
`;
/*

input InputUserAllocPermit {
    userAllocSeq: Int!
    permit: Boolean!
	note: String
}
    userAllocPermit(userAlloc: InputUserAllocPermit!): CommonResponse
*/
export const PERMIT_USER_ALLOC = gql`
mutation PermitUserAlloc($userAlloc:InputUserAllocPermit!) {
    userAllocPermit(userAlloc: $userAlloc) {
        ok
        message
    }
}
`;

/*
userAllocReuse(userAlloc: InputUserAllocReuse!): CommonResponse

input InputUserAllocReuse {
	userId: String!
	password: String!
}
*/
export const REUSE_USER_ALLOC = gql`
mutation ReuseUserAlloc($userAlloc:InputUserAllocReuse!) {
    userAllocReuse(userAlloc: $userAlloc) {
        ok
        message
    }
}
`;

/*
    userAllocItemById(userId:String!): UserAllocSimple

type UserAllocSimple {
	userAllocSeq: Int!
	userId: String
	userName: String
	allocFlag: String
	note: String
}
*/
export const GET_USER_ALLOC_BY_ID = gql`
query GetUserAllocById($userId:String!) {
    userAllocItemById(userId:$userId) {
        userAllocSeq
        userId
        userName
        allocFlag
        note
    }
}
`;

export const LIST_LOOKUPS_UNSAFE = gql`
query ListLookupsUnsafe {
    dcInfoListUnsafe {
        dcCd
        dcName
    }
    storeInfoListUnsafe {
        storeId
        storeName
    }
    comInfoListUnsafe {
        comId
        comName
        dcCd
    }
    authClassListUnsafe {
        authClassId
        className
    }
}
`;

